import { render, staticRenderFns } from "./teamManagementTab.vue?vue&type=template&id=5d3af11a&scoped=true&"
import script from "./teamManagementTab.vue?vue&type=script&lang=js&"
export * from "./teamManagementTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3af11a",
  null
  
)

export default component.exports